// extracted by mini-css-extract-plugin
export default {"textButton":"textButton__TAGPd","button":"button__YdB9L"};